import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Sidebar, MobileSidebar } from './Sidebar';
import { Logo } from '../shared/Logo';
import { Button } from '@/components/ui/button';
import { InstallCTH } from '@/components/shared/InstallCTH';
import { useApp } from '@/context/AppContext';

/**
 * Iter 35 — Role-aware portal label.
 * The /admin/* shell is shared by hm_admin, hm_advisor and hm_reviewer.
 * Each role gets its own pill label so consultants don't see "CTH Admin".
 */
const ROLE_LABEL_KEY = {
  hm_admin:      'i18n:layout.portalAdmin',
  hm_advisor: 'i18n:layout.portalConsultant',
  hm_reviewer:   'i18n:layout.portalReviewer',
};

export const DashboardLayout = ({ nav, portalLabel }) => {
  const { user } = useApp();
  const label = ROLE_LABEL_KEY[user?.role] || portalLabel;
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  return (
    <div className="min-h-screen bg-background">
      <Sidebar nav={nav} portalLabel={label} />
      <MobileSidebar nav={nav} portalLabel={label} open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
      {/* CTH V6.0 PWA — mobile top bar: the admin/client navigation was
          desktop-only (hidden lg:flex); phones need a drawer trigger. */}
      <div className="lg:hidden sticky top-0 z-40 flex items-center gap-2 h-14 px-3 bg-sidebar text-sidebar-foreground border-b border-sidebar-border">
        <Button variant="ghost" size="icon" onClick={() => setMobileNavOpen(true)}
                className="h-10 w-10 text-sidebar-foreground hover:bg-sidebar-accent hover:text-white"
                aria-label="Menu" data-testid="mobile-nav-trigger">
          <Menu className="h-5 w-5" />
        </Button>
        <Logo variant="light" size="sm" />
        <span className="min-[480px]:hidden text-sm font-display font-bold tracking-tight text-white whitespace-nowrap">Corporate Talent Hub</span>
        <div className="ml-auto">
          <InstallCTH iconOnly className="h-10 w-10 p-0 text-sidebar-foreground hover:bg-sidebar-accent hover:text-white" />
        </div>
      </div>
      <div className="lg:pl-72">
        <Outlet />
      </div>
    </div>
  );
};
